import styled from "@emotion/styled";

import { commonColors } from "application/theme";
import { InviteFriendsBannerImage } from "application/assets";

export const Wrapper = styled("div")`
  height: 206px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 20px 16px;
  border-radius: 16px;
  background: url(${InviteFriendsBannerImage});
  background-size: cover;

  > h2 {
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    > span {
      color: ${commonColors.lemonPie};
    }
  }

  > p {
    margin: 6px 0 12px 0;
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    height: 36px;
    padding: 20px 16px;
    align-items: center;
    gap: 10px;
    border-radius: 35px;
    background: ${commonColors.white};
    box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.08);

    //font styles
    color: ${commonColors.grey900};
    text-align: center;
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;

export const Content = styled("div")`
  width: 210px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > h2 {
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    > span {
      color: ${commonColors.lemonPie};
    }
  }

  > p {
    margin: 6px 0 12px 0;
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    height: 36px;
    padding: 20px 16px;
    align-items: center;
    gap: 10px;
    border-radius: 35px;
    background: ${commonColors.white};
    box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.08);

    //font styles
    color: ${commonColors.grey900};
    text-align: center;
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;
